/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as ServerDefs from '../server/defs.defs.js'

const $nsid = 'com.atproto.admin.defs'

export { $nsid }

type StatusAttr = {
  $type?: 'com.atproto.admin.defs#statusAttr'
  applied: boolean
  ref?: string
}

export type { StatusAttr }

const statusAttr = /*#__PURE__*/ l.typedObject<StatusAttr>(
  $nsid,
  'statusAttr',
  /*#__PURE__*/ l.object({
    applied: /*#__PURE__*/ l.boolean(),
    ref: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
  }),
)

export { statusAttr }

type AccountView = {
  $type?: 'com.atproto.admin.defs#accountView'
  did: l.DidString
  handle: l.HandleString
  email?: string
  relatedRecords?: l.LexMap[]
  indexedAt: l.DatetimeString
  invitedBy?: ServerDefs.InviteCode
  invites?: ServerDefs.InviteCode[]
  invitesDisabled?: boolean
  emailConfirmedAt?: l.DatetimeString
  inviteNote?: string
  deactivatedAt?: l.DatetimeString
  threatSignatures?: ThreatSignature[]
}

export type { AccountView }

const accountView = /*#__PURE__*/ l.typedObject<AccountView>(
  $nsid,
  'accountView',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    handle: /*#__PURE__*/ l.string({ format: 'handle' }),
    email: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    relatedRecords: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(/*#__PURE__*/ l.lexMap()),
    ),
    indexedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    invitedBy: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.ref<ServerDefs.InviteCode>(
        (() => ServerDefs.inviteCode) as any,
      ),
    ),
    invites: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<ServerDefs.InviteCode>(
          (() => ServerDefs.inviteCode) as any,
        ),
      ),
    ),
    invitesDisabled: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),
    emailConfirmedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    inviteNote: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
    deactivatedAt: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'datetime' }),
    ),
    threatSignatures: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.array(
        /*#__PURE__*/ l.ref<ThreatSignature>((() => threatSignature) as any),
      ),
    ),
  }),
)

export { accountView }

type RepoRef = { $type?: 'com.atproto.admin.defs#repoRef'; did: l.DidString }

export type { RepoRef }

const repoRef = /*#__PURE__*/ l.typedObject<RepoRef>(
  $nsid,
  'repoRef',
  /*#__PURE__*/ l.object({ did: /*#__PURE__*/ l.string({ format: 'did' }) }),
)

export { repoRef }

type RepoBlobRef = {
  $type?: 'com.atproto.admin.defs#repoBlobRef'
  did: l.DidString
  cid: l.CidString
  recordUri?: l.AtUriString
}

export type { RepoBlobRef }

const repoBlobRef = /*#__PURE__*/ l.typedObject<RepoBlobRef>(
  $nsid,
  'repoBlobRef',
  /*#__PURE__*/ l.object({
    did: /*#__PURE__*/ l.string({ format: 'did' }),
    cid: /*#__PURE__*/ l.string({ format: 'cid' }),
    recordUri: /*#__PURE__*/ l.optional(
      /*#__PURE__*/ l.string({ format: 'at-uri' }),
    ),
  }),
)

export { repoBlobRef }

type ThreatSignature = {
  $type?: 'com.atproto.admin.defs#threatSignature'
  property: string
  value: string
}

export type { ThreatSignature }

const threatSignature = /*#__PURE__*/ l.typedObject<ThreatSignature>(
  $nsid,
  'threatSignature',
  /*#__PURE__*/ l.object({
    property: /*#__PURE__*/ l.string(),
    value: /*#__PURE__*/ l.string(),
  }),
)

export { threatSignature }
